import {AnyCommand, CLEAR_TEAM_COMMAND} from '../type';
import App from '../app';

export default function clearTeam(): AnyCommand {
  return {
    type: CLEAR_TEAM_COMMAND,
  }
}

export const useClearTeamCommand = App.wrapCommand(clearTeam);